import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'


export default {
	name: 'group-mapping',
	components: {
		BasicSelect,
		VueElementLoading,
		Paginate
	},
	props: [],
	data() {
		return {
			isLoadingSearch:false,
			hubzoneLoading: '',
			hubLoading:'',
			rackLoading:'',
			groupLoading:'',
			grouplist: [],
			groupitem: {
				id: '',
				text: ''
			},
			groupid:'',
			PTLDetails:[],
			createdBy:'',
			invalidTokenModal: false,
      invalidtokenmsg: '',
			checkMapModel:false,
			inputData:{},
			cityList: [],
			hubId:'',
			city:'',
			cityDataItem: {
				id: '',
				text: ''
			},
			PTLId:'',
			isroutetypeError:false,
			routetypeerrors:'',
			checkedType:'',
			limit:10,
			offset:0,
			totalRows:'',
			pageCount: 0
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdBy = userdetail[0].email;
		this.hubId=userdetail[0].HubId[0];
		this.getGroups();
		this.getAllCities();

	},
	methods: {
		clearRoutetypeError() {
			console.log(this.checkedType,"checkedType");
			if (this.checkedType == "group") {
				this.rackOrGrp =true;
			} else {
				this.rackOrGrp =false;
			}
		},
		getAllCities() {
			this.hubzoneLoading = 'Loading Cities...'
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				// hubName: this.cityDataItem.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'allcity/get',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubzoneLoading = ''
					let cityData = result.data.ResponseData;
					for (i = 0; i < cityData.length; i++) {
						this.cityList.push({
							id: cityData[i].cityid,
							text:cityData[i].cityname
						})
					}
				}, error => {
					console.error(error)
				})
		},
		selectCity(cityDataItem) {
			this.cityDataItem = cityDataItem
			this.city = this.cityDataItem.id
		},

		selectGroup(groupItem){
			this.groupitem=groupItem
			this.groupid=groupItem.id
		},
		selectRack(rackItem){
			this.rackitem=rackItem
			this.rackid=rackItem.id
		},
		onSubmit: function() {
			this.isroutetypeError=false;
			this.routetypeerrors="";
			var self = this
			this.$validator.validateAll().then((result) => {
				if (this.checkedType.length == 0) {
						this.isroutetypeError=true;
						this.routetypeerrors="Select Group Or Rack"
					return false;
				}
					this.pltMappedGrpList()
			}).catch(() => {
				console.log('errors exist')
			});
		},
		openConfirmationModel(data)
		{
			this.inputData=data;
			this.checkMapModel=true;
		},
		closeConfirmationModel()
		{
			this.checkMapModel=false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		pltMappedGrpList() {
		axios({

				method: 'GET',
				url: apiUrl.api_url_hubops + 'ptlMappedGroupList?isGroup='+this.rackOrGrp+'&ptlId='+this.PTLId+'&groupId='+this.groupid+'&cityId='+this.city+'&limit='+this.limit+'&offset='+this.offset,
				data:this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					'requestfrom': "WEB",
					'token': this.token
				}
			})
			.then(result => {
				this.PTLDetails=[]
				if (result.data.ResultCode == 100) {
					this.invalidTokenModal = false
					this.totalRows = result.data.TotalCount
					if (this.totalRows < 10) {
						this.pageCount = 1
					} else {
						this.pageCount = Math.ceil(this.totalRows / 10);
					}
					this.PTLDetails=result.data.ResponseData
					this.$alertify.success(result.data.ReturnMessage);
				} else if (result.data.ResultCode == 401) {
					this.invalidTokenModal = true
					this.invalidtokenmsg = result.data.ReturnMessage
					this.$alertify.error(result.data.ReturnMessage)
				} else {
					this.invalidTokenModal = false
					this.$alertify.error(result.data.ReturnMessage);
				}
			}, error => {
				console.error(error)
			})
	},
	getPaginationData(pageNum) {
		this.offset = (pageNum - 1)
		this.pltMappedGrpList()
	},
			getGroups() {
				this.grouplist=[]
				this.groupitem={
					id:'',
					text:''
				}
				this.group=''
				this.input={
					currentHubId:this.hubId
				}
				this.$validator.reset();
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'getGroups',
					data:this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						let grouplist=result.data.ResponseData
						for (var i = 0; i < grouplist.length; i++) {
							this.grouplist.push({
								"id": grouplist[i].groupId,
								"text": grouplist[i].groupName,
							})
						}
						this.groupLoading=''
						// this.$alertify.success(result.data.ReturnMessage);
					}else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					}  else {
						this.invalidTokenModal = false
						this.groupLoading='Group details not found'
						// this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					console.error(error)
				})
		},
		preparePrint(data){
			if(data){
				let str = ''; this.isLoadingSearch = true;
					str = str.concat(`^XA
						^SZ2^JMA
						^MCY^PMN
						^PW812
						~JSN
						~SD25^MD0
						^JZY
						^LH0,0^LRN
						^XZ
						^XA
						^FO7,528
						^GB801,0,3^FS
						^FO8,70
						^GB795,0,3^FS
						^FT225,461
						^CI0
						^A0B,102,105^FD${data.groupcode}^FS
						^FT394,472
						^A0B,102,138^FD${((!isNaN(data.binno.charAt(0))) ? data.binno : '')}^FS
						^FO482,202
						^BY4^BCB,102,N,N^FD>:${data.ptlid}^FS
						^FT635,393
						^A0B,56,76^FD${data.ptlid}^FS
						^PQ1,0,1,Y
						^XZ`);

					this.prnData = str;

				this.isLoadingSearch = false;
				if(this.prnData){ this.printerSticker(this.prnData); }
			}else{
				this.$alertify.error('Error: Please check data not found for print action.');
			}
		},
		printerSticker(prnData) {

			this.input = {
				prnData: prnData,
 			 bagNumber: moment().format('DD-MM-YYYY')
			}
			this.isLoadingSearch = true;
			axios({
					method: "POST",
					url: "http://localhost:4500/printer/printbagsticker",
					data: this.input,
				})
				.then(result => {
					console.log(result);
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage);
						this.$validator.reset();
						this.errors.clear();
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					var code = error.response == undefined ? code = 0 : error.response.status;
					if (code == 500) {
						this.$alertify.error("Printer API error");
						console.log(error.response.statusText);
					} else if (error) {
						this.$alertify.error("Printer not connected")
					}
				})
				this.isLoadingSearch = false;
		},

	logout(e) {
		localStorage.removeItem('permissiondata')
		localStorage.removeItem('userdetail')
		localStorage.removeItem('userToken')
		localStorage.removeItem('isLoggedIn')
		localStorage.removeItem('loginDate')
		this.$router.push('/login')
		e.preventDefault()
	},
	closeinvalidTokenModal() {
		this.invalidTokenModal = false
		this.invalidtokenmsg = ''
	},
		resetForm(){
			this.hubzoneLoading=''
			this.groupLoading=''
			this.hubLoading=''
		 	this.isLoadingSearch= false;
		 	this.groupid=''
		 	this.grouplist=[]
		 	this.groupitem={
			 	id:'',
			 	text:''
		 	}
			this.PTLDetails=[]
		 	this.$validator.reset();
			this.checkedType=''
			this.isroutetypeError=false
			this.routetypeerrors=''
			this.PTLId=''
			this.city=''
			this.cityDataItem= {
				id: '',
				text: ''
			}
	 },
	 checkField(data){
		 console.log(data,"data");
		 this.checkedType=data
	 }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/PTLMappingList/PTLMappingList.js